import axios from "axios";
import { useEffect, useState } from "react";

const useAsync = (asyncFunction) => {
  // const [data, setData] = useState([] || {});
  const [data, setData] = useState(null); 
  const [error, setError] = useState("");
  // const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const run = async (...args) => {
    try {
      setIsLoading(true);
      const res = await asyncFunction(...args);
      setData(res);
      setError("");
    } catch (err) {
      if (axios.isCancel(err)) {
        setError(err.message);
        setData([]);
      } else {
        setError(err.message);
        // setData([]);
            setData(null);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    run(); // Trigger the initial async function

    return () => {
      unmounted = true;
      source.cancel("Cancelled in cleanup");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asyncFunction]);

  return {
    data,
    error,
    isLoading,
    run, 
  };
};

export default useAsync;
